import log from '../helpers/Logger';
import YupLoader from './Yup';
import LoggerLoader from './Logger';
import LocaleLoader from './Locale';

export default function init() {
  YupLoader();
  LoggerLoader();
  LocaleLoader();
  log.debug('All loaders run');
}
